// extracted by mini-css-extract-plugin
module.exports = {"form-container":"submissionPreview_form-container__3B-mB","button-container":"submissionPreview_button-container__20NWJ"};